import React from 'react';
import { useSelector } from 'react-redux';

import { AnswerPanel } from './AnswerPanel';
import { FrequentQuestionsPanel } from './FrequentQuestionPanel';
import { getCurrentQuestion } from '../../../selectors/HelpTopicsSelectors';

const MainSection = (props) => {
  const currentQuestion = useSelector(getCurrentQuestion);

  return currentQuestion ? <AnswerPanel {...props} /> : <FrequentQuestionsPanel {...props} />;
};

export default MainSection;
